(function ($)
{
	window.YieldCurveChart = function () { };

	YieldCurveChart.fn = YieldCurveChart.prototype;

	/*****************************
	* Start - Public Methods
	*****************************/

	YieldCurveChart.fn.Initialize = function ()
	{
		this._InputData = {
			Width: 0,
			Height: 0,
			Countries: [],
			DrawingName: null, // It's probably a good idea to set this on the serverside rather than the client.
			Label: null
		};

		this._CHART_XHR = null;
		this._ImageContainer = null;
		this._DRAW_CHART_URL = "~/API/DrawYieldCurveChart";
		this._RegisteredCallbacks = {
			success: null,
			fail: null
		};

		return this; // i enjoy the chainability
	};

	YieldCurveChart.fn.SetInputData = function (objInputs)
	{
		$.extend(true, this._InputData, objInputs);
		return this; // let there be chaining!
	};

	YieldCurveChart.fn.GetInputData = function (bReferenceData)
	{
		if(bReferenceData)
		{
			return this._InputData;
		}
		else
		{
			var objReturnData = {};

			$.extend(true, objReturnData, this._InputData);

			objReturnData.Countries = [];

			for(var i = 0, j = this._InputData.Countries.length; i < j; i++)
			{
				objReturnData.Countries.push(this._InputData.Countries[i].GetInputData(false));
			}

			return objReturnData;
		}
	};

	YieldCurveChart.fn.RegisterSuccessCallback = function (fCallback)
	{
		this._RegisteredCallbacks.success = fCallback;
		return this;
	};

	YieldCurveChart.fn.RegisterFailCallback = function (fCallback)
	{
		this._RegisteredCallbacks.fail = fCallback;
		return this;
	};

	YieldCurveChart.fn.SetDrawChartURL = function (sURL)
	{
		this._DRAW_CHART_URL = sURL;
		return this; // let there be chaining!
	};

	YieldCurveChart.fn.GetDrawChartURL = function ()
	{
		return this._DRAW_CHART_URL;
	};

	YieldCurveChart.fn.SetImageContainer = function (jImageContainer)
	{
		this._ImageContainer = jImageContainer;
		return this; // let there be chaining!
	};

	YieldCurveChart.fn.GetImageContainer = function ()
	{
		return this._ImageContainer;
	};

	YieldCurveChart.fn.Update = function ()
	{
		this._RequestChart();
		return this;
	};

	YieldCurveChart.fn.AddCountry = function (objCountry)
	{
		if (!objCountry) { throw ("Country object cannot be null. Check your inputs and try again"); }

		if (!objCountry.InputData.CountryID || !objCountry.InputData.Color || !objCountry.InputData.Symbols)
		{
			throw ("CountryID, Color, and Symbols are required inputs. Check your inputs and try again");
		}

		this._InputData.Countries.push(objCountry);

		return this; // make it chain!
	};

	YieldCurveChart.fn.RemoveCountry = function ()
	{
		var iCountriesLength = this._InputData.Countries.length;
		var objIndexesToRemove = {};
		var arNewCountries = [];

		for (var i = 0, j = arguments.length; i < j; i++)
		{
			var identifier = arguments[i];

			if (!identifier) { continue; } // no need to mess with nulls

			for (var it = 0; it < iCountriesLength; it++)
			{
				var objCountry = this._InputData.Countries[it].GetInputData();

				if (identifier == objCountry.CountryID)
				{
					objIndexesToRemove[it.toString()] = true;
				}
			}
		}

		for (var i = 0; i < iCountriesLength; i++)
		{
			if (!objIndexesToRemove[i.toString()])
			{
				arNewCountries.push(this._InputData.Countries[i]);
			}
		}

		this._InputData.Countries = arNewCountries;

		return this; // make it chain!
	};

	/*****************************
	* End - Public Methods
	*****************************/

	/*****************************
	* Start - Private Methods
	*****************************/

	YieldCurveChart.fn._RequestChart = function ()
	{
		var context = this;

		// if there is already an XHR request in process cancel it.
		if (this._CHART_XHR)
		{
			try
			{
				if (this._CHART_XHR.abort)
				{
					this._CHART_XHR.abort();
				}
			}
			catch (e)
			{
				// don't do anything. Sometimes IE browsers have a hard time aborting ajax calls. Sounds like a moral issue to me. OOOOOH
			}
		}

		this._CHART_XHR = $.ajax({
			type: "POST",
			url: this._DRAW_CHART_URL.resolveUrl(),
			dataType: "json",
			data: {
				inputData: JSON.stringify(this.GetInputData(false)) // we don't want the reference paths. we want the actual data (InputData) of each item.
			},
			success: function (Response) { context._HandleChartResponse(Response); },
			error: function () { if (window.console && console.log) { console.log(arguments); } }
		});
	};

	YieldCurveChart.fn._HandleChartResponse = function (Response)
	{
		if(!Response) { return; }

		if(Response.FileName)
		{
			this._ImageContainer.attr("src", Response.FileName);
		}
	
		if(this._RegisteredCallbacks.success)
		{
			this._RegisteredCallbacks.success(Response);
		}
	};

	/*****************************
	* End - Private Methods
	*****************************/

})(jQuery);